import { render, staticRenderFns } from "./AtomeWidget.vue?vue&type=template&id=644e56b3&"
import script from "./AtomeWidget.vue?vue&type=script&lang=js&"
export * from "./AtomeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports